/**
 * @xivdyetools/types - AppError Class
 *
 * Custom error class with severity and code.
 *
 * @module error/app-error
 */
/**
 * Custom error class with severity and code
 *
 * Provides structured error information for consistent error handling
 * across the xivdyetools ecosystem.
 *
 * @example
 * ```typescript
 * import { AppError, ErrorCode } from '@xivdyetools/types/error';
 *
 * throw new AppError(
 *   ErrorCode.DYE_NOT_FOUND,
 *   'Dye with ID 999 not found',
 *   'error'
 * );
 * ```
 */
export class AppError extends Error {
    code;
    severity;
    /**
     * Create a new AppError
     *
     * @param code - Error code for programmatic handling
     * @param message - Human-readable error message
     * @param severity - Error severity level (default: 'error')
     */
    constructor(code, message, severity = 'error') {
        super(message);
        this.code = code;
        this.severity = severity;
        this.name = 'AppError';
        // Maintain proper prototype chain
        Object.setPrototypeOf(this, AppError.prototype);
    }
    /**
     * Convert error to JSON-serializable object
     *
     * Useful for logging and API responses.
     *
     * @public implicit `JSON.stringify`/`console.log` serialization hook for
     * consumers — nothing in-repo calls this method by name explicitly, but it
     * is picked up automatically wherever an AppError is serialized.
     */
    toJSON() {
        return {
            name: this.name,
            code: this.code,
            message: this.message,
            severity: this.severity,
            stack: this.stack,
        };
    }
}
//# sourceMappingURL=app-error.js.map